import { toastr } from 'react-redux-toastr'
import brandit_rails from '../api/brandit_rails'
import * as Types from './types'

// fetch locations under specific portal IDs
export const fetchLocationsForPortals = portal_ids => async dispatch => {
  return await brandit_rails
    .get(`/locations/portals?portal_ids=${portal_ids}`)
    .then(function (response) {
      if (response.status === 200) {
        dispatch({ type: 'FETCH_LOCATIONS', payload: response.data })
        return response.data
      }
    })
    .catch(function (error) {
      console.error(error)
    })
}

export const assignLocationsToLocationGroup = (location_ids, locationGroupId) => async dispatch => {
  await brandit_rails.post(`/location_groups/${locationGroupId}/assign_locations`, { location_ids }).then(response => {
    dispatch({ type: Types.ASSIGN_LOCATIONS_TO_LOCATION_GROUP, payload: response.data })
  })
}

export const deleteLocationGroup = locationGroupId => async dispatch => {
  await brandit_rails.delete(`/location_groups/${locationGroupId}`).then(() => {
    dispatch({ type: Types.DELETE_LOCATION_GROUP })
    toastr.success('Success', 'Store View group deleted successfully')
  })
}

export const refreshLocationGroups = () => async dispatch => {
  dispatch({ type: Types.REFRESH_LOCATION_GROUPS })
}

export const savePendingLocations = locationGroupId => async () => {
  await brandit_rails.post(`/location_groups/${locationGroupId}/save_pending_locations`).then(() => {
    toastr.success('Success', 'Store View group updated successfully')
  })
}

export const fetchUserLocationsForGroup = (userId, portalId, locationGroupId) => async dispatch => {
  const response = await brandit_rails.get(`/user_locations/${userId}/${locationGroupId}?`)
  dispatch({ type: Types.FETCH_CUSTOMER_LOCATIONS, payload: { portalId, locationGroupId, data: response.data } })
  return response.data
}

export const submitUserChanges = changes => dispatch => {
  return brandit_rails.post('/user_locations/submit_user_changes', changes).then(() => {
    dispatch({ type: Types.REFRESH_LOGIN_BUTTON, payload: true })
  })
}

export const fetchUserPortals = userId => async () => {
  const response = await brandit_rails.get(`/users/${userId}/user_portal_location_names`)
  return response.data[0]['portals']
}

export const setSelectedCustomerGroup = (selectedCustomerGroup, userId) => ({
  type: Types.SET_SELECTED_CUSTOMER_GROUP,
  payload: { portalId: selectedCustomerGroup.portal_id, userId, data: selectedCustomerGroup }
})

export const toggleUserLocation = (portalId, locationGroupId, locationId, attribute, callback) => ({
  type: Types.TOGGLE_CUSTOMER_LOCATION,
  payload: { locationGroupId, portalId, locationId, attribute, callback }
})

export const toggleUserPortal = (portalId, attribute) => ({
  type: Types.TOGGLE_CUSTOMER_PORTAL,
  payload: { portalId, attribute }
})

export const setAllLocationsAssigned = (portalId, isAssigned, callback) => ({
  type: Types.SET_ALL_LOCATIONS_ASSIGNED,
  payload: { portalId, isAssigned, callback }
})

export const clearUserLocations = locationGroupId => ({
  type: Types.CLEAR_USER_LOCATIONS,
  payload: { locationGroupId }
})

export const setCustomerGroupSystemManaged = (selectedCustomerGroup, systemManaged) => ({
  type: Types.SET_CUSTOMER_GROUP_SYSTEM_MANAGED,
  payload: { portalId: selectedCustomerGroup.portal_id, selectedCustomerGroup, systemManaged }
})

// export const setPortalApproved = portalId => ({
//   type: Types.SET_PORTAL_APPROVED,
//   payload: { portalId },
// })

export const refreshPortalsLocations = () => ({
  type: Types.REFRESH_PORTALS_LOCATIONS
})

export const ccdpListRefreshCount = () => ({
  type: Types.CCDP_LIST_REFRESH_COUNT
})
